var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { CardTitle } from 'reactstrap';
import classnames from 'classnames';
var CordataCardTitle = function CordataCardTitle(_ref) {
  var color = _ref.color,
    children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ['color', 'children', 'className']);
  var classes = classnames('border-bottom', 'pb-2', 'mb-3', {
    'text-primary': color === 'primary',
    'text-secondary': color === 'secondary',
    'text-success': color === 'success',
    'text-warning': color === 'warning',
    'text-danger': color === 'danger',
    'text-info': color === 'info',
    'text-dark': color === 'dark'
  }, className);
  return React.createElement(CardTitle, _extends({
    className: classes
  }, props), children);
};
CordataCardTitle.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
CordataCardTitle.defaultProps = {
  color: 'primary',
  className: ''
};
export default CordataCardTitle;